import React from 'react'

import Navbar from '../../components/navbar/Navbar'

import style from './StudentHome.module.css'

import { useNavigate } from 'react-router-dom'

import { useTranslation } from 'react-i18next'

const StudentHome = () => {

    const { t } = useTranslation()

    const navigate = useNavigate()

  return (

     <>

     <Navbar />

     <div className={style.container}>

        <div className={style.tile}>

        <div className={style.tileBody}>

        <button type="button" onClick={() => navigate('/teachers') }>{t('StudentHome.teachers')}</button>

        </div>

        </div>

        <div className={style.tile}>

        <div className={style.tileBody}>

        <button type="button" onClick={() => navigate('/student-classes')} >{t('StudentHome.classes')}</button>

        </div>

        </div>  

        <div className={style.tile}>

        <div className={style.tileBody}>

        <button type="button" onClick={() => navigate("/reviews")} >{t('StudentHome.reviews')}</button>

        </div>

        </div>

     </div>



    </>

  )

}



export default StudentHome
